export const paging = {
  page: 1,
  pageSize: 9,
  total: 18,
};
